module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-tickets/master-tickets.component.scss
// module id = ./src/app/master/master-tickets/master-tickets.component.scss
// module chunks = main